(function () {
  var dataNode = document.getElementById('sofa-product-data');
  if (!dataNode || !document.getElementById('prime-spec-buttons')) return;
  var product = JSON.parse(dataNode.textContent);
  var compact = /-(parma|modena)$/.test(product.handle);
  var hasMattress = product.handle.indexOf('cu-saltea') !== -1;
  if (document.documentElement.dataset.primeInfoReady) return;
  document.documentElement.dataset.primeInfoReady = 'true';
  var trigger, timer;
  function syncStickyPrice() {
    var mainPrice = document.querySelector('main product-price [ref="priceContainer"]');
    var stickyPrice = document.querySelector('sticky-add-to-cart [ref="priceContainer"]');
    if (mainPrice && stickyPrice && stickyPrice.innerHTML !== mainPrice.innerHTML) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
  }
  function nativeInputs(index) {
    var globo = Array.from(document.querySelectorAll('input[name="globo-option-' + index + '"]'));
    return globo.length ? globo : Array.from(document.querySelectorAll('variant-picker input[data-fieldset-index="' + index + '"]'));
  }
  function nativeValue(index) {
    var input = nativeInputs(index).find(function(i){return i.checked;});
    return input ? input.value : (product.variants[0] && product.variants[0].options[index]) || '';
  }
  function orderDimensions() {
    if (!hasMattress || compact) return;
    var inputs = nativeInputs(0);
    if (!inputs.length || !inputs.every(function(input){return /^\d+\s+loc(?:uri)?\b/i.test(input.value);})) return;
    var rows = inputs.map(function(input){return input.closest('li.select-option');});
    if (rows.some(function(row){return !row || row.parentElement !== rows[0].parentElement;})) return;
    var ordered = rows.slice().sort(function(a,b) {
      var av = a.querySelector('input').value, bv = b.querySelector('input').value;
      return parseInt(av,10) - parseInt(bv,10) || Number(/maxi/i.test(av)) - Number(/maxi/i.test(bv));
    });
    var parent = rows[0].parentElement;
    // Move existing controls, preserving selections, labels and app handlers.
    ordered.forEach(function(row,index) {
      var currentRows = Array.from(parent.children).filter(function(child){return rows.indexOf(child) !== -1;});
      if (currentRows[index] !== row) parent.insertBefore(row,currentRows[index]);
    });
  }
  function reconcile() {
    if (!hasMattress) return;
    var candidates = product.variants;
    for (var index = 0; index < product.options.length; index++) {
      var values = Array.from(new Set(candidates.map(function(v){return v.options[index];})));
      var selectedValue = nativeValue(index);
      // Compatibility is derived from real priced variants, not an independent app matrix.
      nativeInputs(index).forEach(function(input) {
        var wrapper = input.closest('li.select-option');
        if (wrapper) wrapper.hidden = values.indexOf(input.value) === -1;
      });
      if (values.indexOf(selectedValue) === -1) {
        var input = nativeInputs(index).find(function(i){return i.value === values[0];});
        if (input) {
          var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          (label || input).click(); schedule(); return;
        }
      }
      candidates = candidates.filter(function(v){return v.options[index] === selectedValue;});
    }
  }
  function selected(title) {
    var option = Array.from(document.querySelectorAll('.mw-apo-container .mw-option')).find(function (o) {
      var h = o.querySelector('.mw-label .mw-text--style-strong');
      return h && h.textContent.trim() === title;
    });
    var input = option && option.querySelector('input[type="radio"]:checked');
    return input ? input.dataset.primeOriginalLabel || input.getAttribute('aria-label') || input.value : '';
  }
  function current() {
    var dimension = nativeValue(0), n = compact || !hasMattress ? null : parseInt(dimension, 10);
    var height = hasMattress ? parseInt(nativeValue(1), 10) : null;
    var mechanism = hasMattress ? nativeValue(2) : '';
    var width = dimension.match(/saltea\s*(\d+)/i);
    var armSelection = selected('Lățime brațe');
    var arms = armSelection ? parseInt(armSelection, 10) : /-prime$/.test(product.handle) ? 5 : /-riccione$/.test(product.handle) ? 5 : /-rimini-3l$/.test(product.handle) ? 15 : /-parma$/.test(product.handle) ? parseInt(dimension.match(/\d+/)[0],10) : null;
    return { dimension:dimension, n:n, height:height, width:compact ? 140 : width ? Number(width[1]) : null, length:compact ? 200 : height===12 ? 195 : 200, arms:arms, mechanism:mechanism };
  }
  function support(c) {
    return /lamele?.*chingă/i.test(c.mechanism) ? 'Lamele + chingă' : 'Plasă sudată + plasă sudată';
  }
  function seatLabel(c) {
    return c.n === 1 ? (c.width === 100 ? '1 loc maxi' : '1 loc') : c.n ? c.n + ' locuri' : c.dimension;
  }
  function publicMechanism(raw) {
    return raw.replace(/(?:Positano Maxi|Positano|Naxos|Hotel Transverse|Mecanism)\s*H\d+\s*[–—-]?\s*/gi, 'Mecanism – ').replace(/lame \+ chingă/gi, 'Lamele + chingă').replace(/plasă sudată \+ plasă sudată/gi, 'Plasă sudată + plasă sudată');
  }
  function closedDimensions(c) {
    if (/-marco$/.test(product.handle)) {
      var widths = {120:245,140:265,160:285};
      return widths[c.width] ? {width:widths[c.width],height:90,depth:150,shortDepth:90,chaiseWidth:95,seatWidth:c.width,seatChaiseWidth:67,seatLongDepth:110,seatDepth:57} : null;
    }
    // Supplier's top-view sketches: depth is NOT sofa height.
    var corners = {
      // Legacy Amalfi-CL handle belongs to Taormina, now Colțar Amalfi.
      'amalfi-cl':[283,72,155,85,194,64,115,51],
      'cannes-cl':[230,72,155,82,194,72,122,51],
      'capri':[250,87,200,87,200,57,160,57],
      'firenze':[357,108,173,106,324,78,130,66],
      'florida':[290,102,246,87,210,65,197,57],
      'palermo':[290,102,246,87,210,65,197,57],
      'montecarlo':[234,86,214,97,194,57,150,57]
    };
    var key = Object.keys(corners).find(function(model){return product.handle.endsWith('-' + model);});
    if (key) {
      var d = corners[key];
      return {width:d[0],chaiseWidth:d[1],depth:d[2],shortDepth:d[3],seatWidth:d[4],seatChaiseWidth:d[5],seatLongDepth:d[6],seatDepth:d[7],height:90,heightApprox:true};
    }
    if (product.handle.indexOf('cu-saltea') === -1) {
      // Use the merchant's existing exterior dimensions, not the first size of a
      // multi-size product. Parigi's selected 254/328 cm determines the matching pair.
      var exterior = String(c.dimension || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
      var pairs = Array.from(String(product.dimensions || '').matchAll(/(\d+)\s*[x×]\s*(\d+)/gi));
      var selectedWidth = String(c.dimension || '').match(/(?:^|–\s*)(\d+)\s*cm$/i);
      if (!exterior) exterior = selectedWidth ? pairs.find(function(pair){return Number(pair[1]) === Number(selectedWidth[1]);}) : pairs.length === 1 ? pairs[0] : null;
      // The user approved an explicitly approximate 90 cm for unknown heights.
      return exterior ? {width:Number(exterior[1]),depth:Number(exterior[2]),height:90,heightApprox:true} : null;
    }
    // Confirmed closed-sofa measurements supplied by the user on 2026-10-09.
    var match = product.handle.match(/-(prime|milano|modena|parma|rimini(?:-[34]l)?|riccione|roma|verona)$/);
    if (!match) return null;
    var model = match[1].replace(/-[34]l$/, '');
    if (model === 'parma' || model === 'modena') return {width:240,height:90,seatDepth:60};
    var index = [80,100,120,140,160,180].indexOf(c.width);
    if (index === -1) {
      var seats = c.dimension.match(/^(\d+)\s+loc(?:uri)?\b/i);
      if (seats) index = Number(seats[1]) === 1 ? (/maxi/i.test(c.dimension) ? 1 : 0) : Number(seats[1]);
    }
    if (index < 0 || index > 5) return {width:null,height:90,seatDepth:60};
    var widths = model === 'rimini' ? [134,154,174,194,214,234]
      : model === 'milano' || model === 'roma' ? [125,145,165,185,205,225]
      : model === 'prime' && c.arms === 10 ? [125,145,165,185,205,225]
      : [115,135,155,175,195,215];
    if (model === 'prime' && c.arms !== 5 && c.arms !== 10) return {width:null,height:90,seatDepth:60};
    return {width:widths[index],height:90,seatDepth:60};
  }
  function drawCornerDimensions(host, dimensions) {
    // Supplier top-view dimensions. Both outlines are schematic, not to scale.
    var ns = 'http://www.w3.org/2000/svg';
    var svg;
    var diagrams = document.createElement('div');
    diagrams.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr));gap:16px';
    function element(tag, attributes, text) {
      var node = document.createElementNS(ns, tag);
      Object.keys(attributes).forEach(function(key) { node.setAttribute(key, attributes[key]); });
      if (text !== undefined) node.textContent = text;
      svg.appendChild(node);
      return node;
    }
    function label(x, y, text, rotate) {
      var attributes = {x:x,y:y,'text-anchor':'middle','font-size':18,'font-weight':600};
      if (rotate) attributes.transform = 'rotate(-90 ' + x + ' ' + y + ')';
      element('text', attributes, text);
    }
    function horizontal(x1, x2, y, value) {
      element('path', {d:'M' + x1 + ' ' + y + 'H' + x2 + 'M' + x1 + ' ' + (y-6) + 'v12M' + x2 + ' ' + (y-6) + 'v12',fill:'none',stroke:'#333','stroke-width':1.5});
      label((x1+x2)/2, y-12, value + ' cm');
    }
    function vertical(x, y1, y2, value, side) {
      element('path', {d:'M' + x + ' ' + y1 + 'V' + y2 + 'M' + (x-6) + ' ' + y1 + 'h12M' + (x-6) + ' ' + y2 + 'h12',fill:'none',stroke:'#333','stroke-width':1.5});
      label(x + side*20, (y1+y2)/2, value + ' cm', true);
    }
    function panel(offset, title, width, shortDepth, longDepth, chaiseWidth) {
      var x1 = offset+70, x2 = offset+410, corner = offset+295;
      label(offset+240, 35, title);
      element('path', {d:'M' + x1 + ' 110H' + x2 + 'V360H' + corner + 'V245H' + x1 + 'Z',fill:'#f6f3ee',stroke:'#333','stroke-width':2});
      horizontal(x1,x2,80,width);
      horizontal(corner,x2,408,chaiseWidth);
      vertical(offset+40,110,245,shortDepth,-1);
      vertical(offset+440,110,360,longDepth,1);
    }
    [
      ['Canapea – total',dimensions.width,dimensions.shortDepth,dimensions.depth,dimensions.chaiseWidth],
      ['Suprafață utilă de ședere',dimensions.seatWidth,dimensions.seatDepth,dimensions.seatLongDepth,dimensions.seatChaiseWidth]
    ].forEach(function(values) {
      svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 500 440');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', values[0] + ', conform tabelului furnizorului');
      panel(0,values[0],values[1],values[2],values[3],values[4]);
      diagrams.appendChild(svg);
    });
    host.appendChild(diagrams);
    var note = document.createElement('p'); note.className = 'prime-system-note'; note.textContent = 'Schiță orientativă, nu la scară'; host.appendChild(note);
  }
  function selectedTableFacts(c) {
    var confirmed = closedDimensions(c);
    var dimensions = confirmed && confirmed.width && confirmed.depth
      ? confirmed.width + ' × ' + confirmed.depth + ' cm'
      : confirmed && confirmed.width ? confirmed.width + ' cm' : '';
    var labels = document.getElementById('prime-spec-buttons').dataset;
    // Do not turn seat depth into exterior depth, or infer missing supplier data.
    if (dimensions && confirmed.height) dimensions += '; ' + labels.heightLabel + ': ' + (confirmed.heightApprox ? 'aprox. ' : '') + confirmed.height + ' cm';
    if (dimensions && confirmed.seatDepth) dimensions += '; ' + labels.seatDepthLabel + ': ' + confirmed.seatDepth + ' cm';
    return { dimensions: dimensions, seats: c.n ? seatLabel(c) : '' };
  }
  function syncSelectedTable(c) {
    var facts = selectedTableFacts(c);
    document.querySelectorAll('main table[class*="ai-product-specs-table"]').forEach(function(table) {
      table.querySelectorAll('tr').forEach(function(row) {
        if (row.cells.length !== 2) return;
        var label = row.cells[0].textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
        var value = label === 'dimensiuni' ? facts.dimensions : label === 'numar locuri' ? facts.seats : '';
        if (value && row.cells[1].textContent.trim() !== value) row.cells[1].textContent = value;
      });
    });
  }
  function drawSofa(host, c) {
    host.replaceChildren();
    var title = document.createElement('h3'); title.className = 'sofa-sheet-title'; title.textContent = 'DIMENSIUNI: ' + product.name; host.appendChild(title);
    var closed = document.createElement('figure'); closed.className = 'sofa-sheet-closed';
    var closedTitle = document.createElement('h4'); closedTitle.textContent = 'Canapea închisă'; closed.appendChild(closedTitle);
    var exterior = (c.dimension.match(/(?:Total\s*)?(\d+)\s*[x×]\s*(\d+)/i) || String(product.dimensions || '').match(/(?:Total\s*)?(\d+)\s*[x×]\s*(\d+)/i));
    var confirmed = closedDimensions(c);
    var closedWidth = confirmed && confirmed.width ? confirmed.width + ' cm' : exterior ? exterior[1] + ' cm' : '';
    var closedHeight = confirmed && confirmed.height ? (confirmed.heightApprox ? 'aprox. ' : '') + confirmed.height + ' cm' : 'aprox. 90 cm';
    var photoFrame = document.createElement('div');
    photoFrame.innerHTML = '<svg viewBox="0 0 800 385" role="img" aria-label="Canapeaua închisă și dimensiunile exterioare disponibile"><image x="115" y="10" width="570" height="285" preserveAspectRatio="xMidYMid meet"/><g fill="none" stroke="#333" stroke-width="1.4"><path d="M175 307H625M175 300v14M625 300v14M704 65v218M697 65h14M697 283h14"/></g><text x="400" y="336" text-anchor="middle" class="prime-dimension"></text><text x="720" y="165" text-anchor="middle" transform="rotate(-90 720 165)" class="prime-dimension"></text></svg>';
    photoFrame.querySelector('image').setAttribute('href', product.image);
    var photoLabels = photoFrame.querySelectorAll('text'); photoLabels[0].textContent = closedWidth; photoLabels[1].textContent = closedHeight;
    var axes = photoFrame.querySelector('path');
    axes.setAttribute('d', (closedWidth ? 'M175 307H625M175 300v14M625 300v14' : '') + (closedHeight ? 'M704 65v218M697 65h14M697 283h14' : ''));
    closed.appendChild(photoFrame);
    var caption = document.createElement('figcaption'); caption.textContent = [hasMattress ? seatLabel(c) : '', c.arms ? 'Brațe: ' + c.arms + ' cm' : '', confirmed && confirmed.seatDepth ? 'Adâncime șezut: ' + confirmed.seatDepth + ' cm' : '', confirmed && confirmed.depth ? 'Adâncime totală: ' + confirmed.depth + ' cm' : exterior ? 'Adâncime totală: ' + exterior[2] + ' cm' : ''].filter(Boolean).join(' · '); closed.appendChild(caption); host.appendChild(closed);
    if (confirmed && confirmed.chaiseWidth) {
      var details = document.createElement('p');
      details.textContent = 'Dimensiuni totale: ' + confirmed.width + ' × ' + confirmed.depth + ' cm; adâncime partea scurtă: ' + confirmed.shortDepth + ' cm; lățime șezlong: ' + confirmed.chaiseWidth + ' cm. Suprafață utilă de ședere: lățime ' + confirmed.seatWidth + ' cm; adâncimi ' + confirmed.seatDepth + ' / ' + confirmed.seatLongDepth + ' cm; lățime partea utilă a șezlongului: ' + confirmed.seatChaiseWidth + ' cm.';
      host.appendChild(details);
    }
    var sketch = (product.images || []).find(function(image){return /dimensiuni|schit[aă]/i.test(image.url + ' ' + (image.alt || ''));});
    // Mattress sofas use dynamic dimensions; a static gallery sketch may depict another configuration.
    if (confirmed && confirmed.chaiseWidth) {
      drawCornerDimensions(host, confirmed);
    } else if (sketch && !hasMattress && !/-parigi$/.test(product.handle)) {
      var sheet = document.createElement('img'); sheet.src = sketch.url; sheet.alt = 'Schiță dimensională ' + product.name; sheet.style.cssText = 'display:block;width:100%;height:auto;margin:18px 0'; host.appendChild(sheet);
    }
    if (!hasMattress) {
      // Confirmed dimensions already have a complete diagram and facts above.
      // Keep the full merchant description on the product page, without repeating
      // it a second time in this technical dialog.
      if (!confirmed) {
        var description = document.createElement('div'); description.appendChild(document.getElementById('sofa-description-source').content.cloneNode(true)); host.appendChild(description);
      }
      return;
    }
    var openTitle = document.createElement('h4'); openTitle.textContent = 'Canapea deschisă (pat)'; host.appendChild(openTitle);
    if (compact) {
      var mechanism = document.createElement('img'); mechanism.className = 'sofa-product-photo'; mechanism.src = document.getElementById('prime-spec-dialog').dataset.compactOpen; mechanism.alt = 'Mecanism compact deschis – imagine de referință'; host.appendChild(mechanism);
    } else {
      // Preserve the user's artwork exactly. Old printed values are covered by
      // white SVG panels and replaced with text from the selected configuration.
      // The image itself is not redrawn or geometrically distorted.
      var drawing = document.createElement('div');
      drawing.innerHTML = '<svg viewBox="0 0 1120 520" role="img" aria-label="Designul de referință cu dimensiunile dinamice ale saltelei"><image x="-280" y="-485" width="1586" height="992"/><g fill="white"><rect x="0" y="0" width="225" height="65"/><rect x="480" y="115" width="160" height="53"/><rect x="0" y="173" width="133" height="66"/><rect x="975" y="292" width="140" height="60"/><rect x="465" y="428" width="190" height="65"/></g><g style="font-family:Arial,sans-serif;font-size:32px;font-weight:700" fill="#111" text-anchor="middle"><text x="557" y="153">' + c.width + ' cm</text><text x="66" y="221">' + c.length + ' cm</text><text x="1038" y="338">' + c.height + ' cm</text><text x="558" y="472">' + (c.width + (c.height === 12 ? 20 : c.width < 120 ? 20 : 22)) + ' cm</text></g></svg>';
      drawing.querySelector('image').setAttribute('href', document.getElementById('prime-spec-dialog').dataset.sofaReference);
      // Marco supplier table: mechanism 140/160/180 for mattresses 120/140/160.
      if (/-marco$/.test(product.handle)) drawing.querySelector('text:last-child').textContent = (c.width + 20) + ' cm';
      host.appendChild(drawing);
      var referenceNote = document.createElement('p'); referenceNote.className = 'sofa-reference-note'; referenceNote.textContent = 'Imagine orientativă comună. Cotele indică salteaua (lățime × lungime × înălțime) și lățimea mecanismului, nu adâncimea totală a canapelei deschise.'; host.appendChild(referenceNote);
    }
  }
  function sanitizeOptionLabels() {
    document.querySelectorAll('.mw-apo-container .mw-option').forEach(function (option) {
      var heading = option.querySelector('.mw-label .mw-text--style-strong');
      if (!heading || !/^Mecanism – /i.test(heading.textContent.trim())) return;
      option.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var raw = input.dataset.primeOriginalLabel || input.getAttribute('aria-label') || '';
        if (!input.dataset.primeOriginalLabel) input.dataset.primeOriginalLabel = raw;
        var label = publicMechanism(raw);
        if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
      });
      var walker = document.createTreeWalker(option, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var cleaned = publicMechanism(node.nodeValue);
        if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
      }
    });
  }
  function drawMattress(host, c) {
    var crib = c.height === 12, model = crib ? 'Crib' : 'Simple White';
    var plane = 'M65 88L245 20Q253 17 262 21L457 104Q468 109 455 115L284 182Q275 186 265 181L65 100Q53 94 65 88Z';
    var notes = crib ? [
      ['Husă matlasată', 'Material 100% poliester. Husă fixă, nedetașabilă.'],
      ['Miez Water Foam · D21', 'Un singur miez din spumă, cu densitate de 21 kg/m³.'],
      ['Înveliș textil', 'Husa înconjoară și protejează miezul de spumă.']
    ] : [
      ['Panou superior alb', 'Spandex, poliester 420 g/m² și material nețesut.'],
      ['Miez din spumă · D25', 'Miez de susținere cu densitate de 25 kg/m³.'],
      ['Panou inferior', 'Material 100% poliester. Bandă laterală din material gri 3D.']
    ];
    host.innerHTML = '<div class="prime-layer-layout"><svg viewBox="0 0 520 435" role="img" aria-label="Structura ilustrată a saltelei ' + model + ': înveliș textil și miez din spumă D' + (crib ? '21' : '25') + '">' +
      '<defs><linearGradient id="prime-cover" x2="0.3" y2="1"><stop stop-color="#fff"/><stop offset="1" stop-color="#eae7e1"/></linearGradient><linearGradient id="prime-core" x2="0.2" y2="1"><stop stop-color="#f3e7cc"/><stop offset="1" stop-color="#d6bf91"/></linearGradient><pattern id="prime-quilting" width="32" height="26" patternUnits="userSpaceOnUse"><path d="M16 0L32 13 16 26 0 13Z" fill="none" stroke="#d7d3cc" stroke-width=".7"/></pattern><pattern id="prime-pores" width="17" height="15" patternUnits="userSpaceOnUse"><circle cx="4" cy="5" r="1.1" fill="#b49b6c" opacity=".4"/><circle cx="13" cy="12" r=".7" fill="#b49b6c" opacity=".35"/></pattern><filter id="prime-layer-shadow" x="-20%" y="-20%" width="140%" height="160%"><feDropShadow dx="0" dy="9" stdDeviation="7" flood-color="#776b56" flood-opacity=".12"/></filter></defs>' +
      '<ellipse cx="269" cy="393" rx="193" ry="27" fill="#d9d2c7" opacity=".2"/>' +
      '<g transform="translate(0 218)" filter="url(#prime-layer-shadow)"><path d="M61 94L276 184 460 110v8L276 192 61 102Z" fill="#d1ccc3"/><path d="' + plane + '" fill="url(#prime-cover)" stroke="#d3cec5" stroke-width="1"/></g>' +
      '<g transform="translate(0 105)" filter="url(#prime-layer-shadow)"><path d="M61 94L276 184v39L61 134Z" fill="#ceb487"/><path d="M276 184L460 110v39L276 223Z" fill="#bfa476"/><path d="' + plane + '" fill="url(#prime-core)" stroke="#cfb98e"/><path d="' + plane + '" fill="url(#prime-pores)"/><path d="M61 94L276 184v39L61 134Z" fill="url(#prime-pores)"/></g>' +
      '<g filter="url(#prime-layer-shadow)"><path d="M61 94L276 184 460 110v9L276 194 61 105Z" fill="#ddd8ce"/><path d="' + plane + '" fill="url(#prime-cover)" stroke="#d6d1c8"/><path d="' + plane + '" fill="url(#prime-quilting)"/><path d="M67 97L275 182 453 113" fill="none" stroke="#fff" stroke-width="3"/></g>' +
      '<g font-family="Arial,sans-serif" font-size="12" font-weight="600" fill="#756852" text-anchor="middle"><circle cx="36" cy="86" r="15" fill="#fffdf8" stroke="#d9cfc0"/><text x="36" y="90">01</text><circle cx="36" cy="222" r="15" fill="#fffdf8" stroke="#d9cfc0"/><text x="36" y="226">02</text><circle cx="36" cy="348" r="15" fill="#fffdf8" stroke="#d9cfc0"/><text x="36" y="352">03</text></g></svg>' +
      '<div class="prime-layer-notes">' + notes.map(function(note, i) { return '<div class="prime-layer-note"><span class="prime-layer-number">0' + (i + 1) + '</span><div><b>' + note[0] + '</b><p>' + note[1] + '</p></div></div>'; }).join('') + '</div></div>' +
      '<div class="prime-mattress-badges"><span>' + model + '</span><span>' + c.width + ' × ' + c.length + ' cm</span><span>Înălțime ' + c.height + ' cm</span><span>Spumă D' + (crib ? '21' : '25') + '</span></div>';
  }
  function content(kind) {
    var c = current();
    var confirmed = closedDimensions(c);
    var exteriorLabel = confirmed && confirmed.width && confirmed.depth
      ? confirmed.width + ' × ' + confirmed.depth + ' cm' : (product.dimensions || c.dimension);
    if (kind === 'sofa' && !hasMattress) return {title:product.name,items:[
      'Configurație selectată: ' + c.dimension + '.',
      'Dimensiuni totale: ' + exteriorLabel + '.',
      'Înălțime: ' + (confirmed && confirmed.height && !confirmed.heightApprox ? confirmed.height + ' cm.' : 'aprox. 90 cm (estimare).'),
      'Tapițeria, culoarea și picioarele corespund selecției din configurator.'
    ]};
    if (!c.mechanism || !c.height) return {title:'Selectează configurația',items:['Alege dimensiunea, înălțimea saltelei și mecanismul pentru a vedea specificațiile.']};
    if (kind === 'sofa') return {title:product.name + ' – ' + seatLabel(c),items:[
      'Canapea extensibilă realizată la comandă, cu saltea inclusă.',
      (c.arms ? 'Brațe de ' + c.arms + ' cm; ' : '') + 'tapițerie și picioare conform selecției din configurator.',
      'Saltea ' + (c.height === 12 ? 'Crib' : 'Simple White') + ': ' + c.width + ' × ' + c.length + ' × ' + c.height + ' cm.',
      'Mecanism: ' + support(c) + '.',
      closedDimensions(c) && closedDimensions(c).width
        ? 'Canapea închisă: lățime ' + closedDimensions(c).width + ' cm; înălțime ' + closedDimensions(c).height + ' cm; adâncime șezut ' + closedDimensions(c).seatDepth + ' cm. Schiță orientativă, nu la scară.'
        : 'Dimensiunile disponibile sunt prezentate în schița produsului. Ilustrația comună a mecanismului nu este la scară.'
    ]};
    if (kind === 'mechanism') return {
      title: 'Mecanism – ' + support(c),
      items: ['Configurație: ' + seatLabel(c) + '.', 'Lățime saltea: ' + c.width + ' cm.', 'Înălțime saltea compatibilă: ' + c.height + ' cm.',
        support(c) === 'Lamele + chingă' ? 'Suport de dormit cu lamele din lemn; șezut cu chingi.' : 'Suport de dormit și șezut cu plasă sudată.',
        support(c) !== 'Plasă sudată + plasă sudată' ? 'Mecanism opțional. Suplimentul este deja inclus în prețul configurației selectate.' : 'Mecanism standard inclus în prețul configurației.',
        c.height === 21 ? 'Pentru această configurație H21 este disponibilă doar construcția plasă sudată + plasă sudată.' : 'Se afișează doar construcțiile compatibile cu dimensiunea și înălțimea selectate.',
        ...(c.height > 12 ? ['Deschidere prin rabatarea spătarului și desfășurarea mecanismului, fără îndepărtarea pernelor de șezut și spătar.', 'Cadru din tuburi de oțel laminat la rece, cu finisaj din rășină epoxidică aplicată electrostatic.'] : []),
        ...(support(c) === 'Lamele + chingă' ? [c.width === 120 ? 'Lamele simple, cu suport inferior suplimentar, conform construcției ilustrate în catalog.' : 'Lamele duble, cu suport central suplimentar, conform construcției ilustrate în catalog.', 'Opritoare pentru saltea și suport plat în zona capului.', 'Chingi în zona șezutului pentru confort în poziția de canapea.'] : [])]
    };
    var crib = c.height === 12;
    return {title: 'Saltea ' + (crib ? 'Crib' : 'Simple White') + ' – ' + c.height + ' cm', items:[
      'Inclusă în prețul canapelei.', 'Dimensiuni: ' + c.width + ' × ' + c.length + ' × ' + c.height + ' cm.',
      crib ? 'Miez din spumă Water Foam, densitate 21 kg/m³.' : 'Miez din spumă, densitate 25 kg/m³.',
      'Compatibilă cu mecanismul selectat.',
      ...(crib ? ['Construcție cu un singur strat de spumă și susținere medie.', 'Husă fixă, nedetașabilă, din material 100% poliester, cu partea superioară matlasată.', 'Înveliș antiacarieni și antimucegai, conform etichetei produsului.', 'Materialul husei este indicat pe eticheta produsului ca fiind certificat OEKO-TEX STANDARD 100.'] : ['Panou superior: material alb Spandex, poliester 420 g/m² și material nețesut.', 'Bandă laterală: material gri 3D, poliester 210 g/m² și material nețesut.', 'Panou inferior: material 100% poliester.'])]};
  }
  function paint(kind) {
    var d = content(kind), dialog = document.getElementById('prime-spec-dialog');
    dialog.querySelector('h2').textContent = d.title;
    var list = dialog.querySelector('ul'); list.replaceChildren();
    d.items.forEach(function (text) { var li = document.createElement('li'); li.textContent = text; list.appendChild(li); });
    dialog.dataset.kind = kind;
    var c = current(), isSystem = kind === 'mechanism' && !!c.mechanism;
    var visual = dialog.querySelector('.prime-system-visual');
    var slats = support(c) === 'Lamele + chingă';
    var hasPhoto = isSystem;
    visual.hidden = !hasPhoto;
    if (hasPhoto) {
      visual.querySelector('[data-system-photo="folded"]').src = slats ? (c.width === 120 ? dialog.dataset.singleDetail : dialog.dataset.doubleDetail) : c.height === 12 ? dialog.dataset.h12Folded : c.height === 21 ? dialog.dataset.maxiFolded : dialog.dataset.positanoFolded;
      visual.querySelector('[data-system-photo="open"]').src = slats ? (c.width === 120 ? dialog.dataset.singleOpen : dialog.dataset.doubleOpen) : c.height === 12 ? dialog.dataset.h12Open : dialog.dataset.positanoOpen;
      visual.querySelector('[data-system-photo="side"]').src = dialog.dataset.side;
      visual.querySelector('[data-side-figure]').hidden = !slats;
      visual.querySelector('[data-photo-caption="folded"]').textContent = slats ? 'Detaliu: lamele și chingi în poziție pliată' : 'Poziție închisă';
      if (compact) {
        visual.querySelector('[data-system-photo="open"]').src = dialog.dataset.compactOpen;
        visual.querySelector('[data-system-photo="folded"]').closest('figure').hidden = true;
      } else visual.querySelector('[data-system-photo="folded"]').closest('figure').hidden = false;
    }
    dialog.querySelector('.prime-system-care').hidden = !isSystem || c.height === 12 || compact;
    var diagram = dialog.querySelector('.prime-sofa-diagram'); diagram.hidden = kind !== 'sofa';
    if (kind === 'sofa') {
      drawSofa(diagram, c);
    }
    var mattressVisual = dialog.querySelector('.prime-mattress-visual');
    mattressVisual.hidden = kind !== 'mattress';
    if (kind === 'mattress') {
      var crib = c.height === 12, model = crib ? 'Crib' : 'Simple White';
      var photo = crib ? dialog.dataset.cribPhoto : dialog.dataset.simplePhoto;
      mattressVisual.querySelectorAll('[data-mattress-photo]').forEach(function(img) { img.src = photo; });
      mattressVisual.querySelector('[data-mattress-caption]').textContent = crib ? 'Crib · fotografie furnizată de producător. Dimensiuni selectate: ' + c.width + ' × ' + c.length + ' × ' + c.height + ' cm.' : 'Simple White · fotografie de referință retușată pentru eliminarea brandingului. Dimensiuni selectate: ' + c.width + ' × ' + c.length + ' × ' + c.height + ' cm.';
      drawMattress(mattressVisual.querySelector('[data-mattress-section]'), c);
    }
    var features = dialog.querySelector('.prime-system-features'); features.hidden = !isSystem;
    if (isSystem) {
      dialog.querySelector('[data-feature="system"]').textContent = 'Mecanism pentru saltea de ' + c.height + ' cm';
      dialog.querySelector('[data-feature="size"]').textContent = 'Saltea: lățime ' + c.width + ' cm / înălțime ' + c.height + ' cm';
      dialog.querySelector('[data-feature="support"]').textContent = support(c);
    }
  }
  function update() {
    var host = document.getElementById('prime-spec-buttons');
    if (!host) return;
    var oldGroups = Array.from(document.querySelectorAll('h2')).filter(function(h){return /Vezi informa[tț]ii (sisteme extensibile|somiera|saltea)/i.test(h.textContent);}).map(function(h){return h.closest('[data-testid="group-block"]');}).filter(Boolean);
    var old = oldGroups[0];
    if (old && host.parentNode !== old.parentNode) old.before(host);
    // The legacy sofa script restores display on the real product URL.
    // Remove its redundant block from this pilot's DOM, rather than competing over styles.
    oldGroups.forEach(function(g){g.remove();});
    var accordion = Array.from(document.querySelectorAll('button,summary')).find(function(b){return b.textContent.trim()==='Descriere';});
    if (accordion && !host.closest('product-information, .product-details')) {
      var row = accordion.closest('accordion-custom, details, [data-testid="collapsible-row"]') || accordion.parentElement;
      if (row.previousElementSibling !== host) row.before(host);
    }
    var armPicker = Array.from(document.querySelectorAll('.mw-apo-container .mw-option')).find(function(o){
      var label = o.querySelector('.mw-label .mw-text--style-strong');
      return label && label.textContent.trim() === 'Lățime brațe';
    });
    if (armPicker && armPicker.parentElement.firstElementChild !== armPicker) armPicker.parentElement.prepend(armPicker);
    orderDimensions();
    reconcile();
    sanitizeOptionLabels();
    syncStickyPrice();
    var c = current();
    syncSelectedTable(c);
    host.querySelector('[data-prime-kind="mechanism"]').hidden = !hasMattress;
    host.querySelector('[data-prime-kind="mattress"]').hidden = !hasMattress;
    var mechanismText = c.mechanism ? support(c) : 'Alege mecanismul';
    var mattressText = c.height ? (c.height === 12 ? 'Crib' : 'Simple White') + ' – ' + c.height + ' cm' : 'Alege salteaua';
    var mechanismNode = host.querySelector('[data-prime-current="mechanism"]');
    var mattressNode = host.querySelector('[data-prime-current="mattress"]');
    if (mechanismNode.textContent !== mechanismText) mechanismNode.textContent = mechanismText;
    if (mattressNode.textContent !== mattressText) mattressNode.textContent = mattressText;
    var sofaNode = host.querySelector('[data-prime-current="sofa"]');
    var sofaText = seatLabel(c) + (c.arms && !/brațe/i.test(c.dimension) ? ' · brațe ' + c.arms + ' cm' : '');
    if (sofaNode.textContent !== sofaText) sofaNode.textContent = sofaText;
    // Zero-price standard choices are explicitly described as included.
    document.querySelectorAll('.mw-apo-container .mw-option__value').forEach(function (v) {
      var i = v.querySelector('input[type="radio"]');
      if (!i || !/plasă sudată \+ plasă sudată$/i.test(i.getAttribute('aria-label') || '')) return;
      var label = v.querySelector('.mw-option__value-title');
      if (label && !label.querySelector('.prime-included')) {
        var s = document.createElement('span'); s.className = 'prime-included'; s.textContent = ' — Inclus'; label.appendChild(s);
      }
    });
    var dialog = document.getElementById('prime-spec-dialog');
    var key = JSON.stringify(c);
    if (dialog.open && dialog.dataset.selection !== key) paint(dialog.dataset.kind);
    dialog.dataset.selection = key;
  }
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; update(); }, 40);
  }
  var dialog = document.getElementById('prime-spec-dialog');
  document.getElementById('prime-spec-buttons').addEventListener('click', function (e) {
    var button = e.target.closest('[data-prime-kind]'); if (!button) return;
    trigger = button; paint(button.dataset.primeKind); dialog.showModal();
    dialog.querySelector('button').focus();
  });
  dialog.querySelector('button').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('close', function () { if (trigger) trigger.focus(); });
  document.addEventListener('change', schedule, true);
  // APO buttons otherwise toggle an already selected required radio off.
  // Scope this to the sofa's named, required single-choice groups; optional
  // choices, checkboxes and switching to another value remain untouched.
  var repeatRequiredTarget = null;
  function requiredRadioValue(value) {
    var option = value && value.closest('.mw-option');
    if (!option || !option.classList.contains('mw-option--required')) return null;
    var heading = option.querySelector('.mw-label .mw-text--style-strong');
    if (!heading || !/^(?:Mecanism – |Culoare tapițerie$|Picioare$|Lățime brațe$)/.test(heading.textContent.trim())) return null;
    var inputs = Array.from(option.querySelectorAll('.mw-option__control'));
    var input = value.querySelector('input[type="radio"]');
    if (!input || !inputs.length || inputs.some(function(i){return i.type !== 'radio' || i.name !== input.name;})) return null;
    return input;
  }
  function preventRequiredRadioClear(e) {
    if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
    var value = e.target.closest && e.target.closest('.mw-option__value');
    if (!value) return;
    var input = requiredRadioValue(value);
    if (e.type === 'pointerdown') {
      repeatRequiredTarget = input && input.checked ? input : null;
      return;
    }
    if (input && (e.type === 'keydown' ? input.checked : repeatRequiredTarget === input)) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }
  document.addEventListener('pointerdown', preventRequiredRadioClear, true);
  document.addEventListener('click', preventRequiredRadioClear, true);
  document.addEventListener('keydown', preventRequiredRadioClear, true);
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  update();
})();
